import React from 'react';
import { Circle, MapContainer, Marker, Polygon, TileLayer, useMapEvent } from "react-leaflet";
import TrueSize from "./TrueSize";
import { decodePolygon } from "../utils";
import { getColors, PLANET_MAP } from "../constants";


function ClickComponent(props) {
  const map = useMapEvent('click', (e) => {
    if (props.mapClick !== undefined) {
      props.mapClick(e.latlng.lat, e.latlng.lng);
    }
  });

  return null;
}


class LeafletMap extends React.Component {
  constructor(props) {
    super(props);
    this.mapLoaded = false;
    this.state = {...this.state, height: this.height()};
    window.onresize = this.onResize;
    this.colors = getColors(props.theme);
    const planet = props.planet ? props.planet.toUpperCase() : 'EARTH';
    this.planet = PLANET_MAP[planet];
  }

  static preparePolygon = (polygon, useDecode = true) => {
    if (!useDecode) {
      return polygon.map(polygon => polygon.map(point => [point.lng(), point.lat()]));
    }

    return decodePolygon(polygon).map(polygon => polygon.map(point => [point.lat(), point.lng()]));
  };

  onResize = () => {
    this.setState({...this.state, height: this.height()});
  };

  height = () => {
    return window.innerHeight - 54 - 42;
  };

  handleMapLoad = (map) => {
    this._mapComponent = map;
    // load regions from server only at the first time
    if (map && this.props.initCallback && !this.mapLoaded) {
      this.mapLoaded = true;
      this.props.initCallback(map);
    }
  };

  commonOptions(shape, color) {
    return {
      stroke: true,
      color: color,
      opacity: 0.8,
      weight: 2,
      fill: true,
      fillColor: color,
      fillOpacity: 0.35,
      id: shape.id,
    };
  }

  preparePolygons(polygons) {
    if (!polygons) {
      return [];
    }
    return polygons.map(polygon => {
      let color = polygon.isSolved ? this.colors.SOLVED : this.colors.WRONG;
      let result = this.commonOptions(polygon, color);
      result.key = `${polygon.draggable}${polygon.id}`;
      result.draggable = polygon.draggable;
      // result.options.zIndex = polygon.draggable ? 2 : 1;
      result.pathOptions = this.commonOptions(polygon, color);
      result.id = polygon.id;
      result.positions = polygon.paths;
      result.defaultPosition = polygon.defaultPosition;
      return result;
    });
  }

  preparePoints(locations) {
    if (!locations) {
      return [];
    }
    let scale = this.props.zoom - 2;
    return locations.map(location => {
      let color = location.isChecking ? this.colors.CHECKING : (location.isSolved ? this.colors.SOLVED : (location.draggable ? this.colors.UNKNOWN : this.colors.WRONG));
      let result = this.commonOptions(location, color);
      result.pathOptions = this.commonOptions(location, color);
      result.key = `${location.id}`;
      result.center = [location.point.lat, location.point.lng];
      result.radius = this.planet.radius / scale / Math.log(scale + 3);
      return result;
    });
  }

  showMarker(infobox) {
    if (infobox) {
      return {
        key: 'center',
        defaultAnimation: 2,
        position: [infobox.marker.lat, infobox.marker.lng],
      }
    }
  }

  render() {
    let props = {...this.props};
    if (!this.props.showMap) {
      return null;
    }
    let marker = this.showMarker(this.props.infobox);
    return <MapContainer center={[props.center.lat, props.center.lng]}
                         zoom={props.zoom} minZoom={this.planet.minZoom} maxZoom={this.planet.maxZoom} zoomDelta={0.5}
                whenReady={this.handleMapLoad}
                style={{height: this.state.height, width: "100%"}}>
      <ClickComponent mapClick={this.props.mapClick}/>
      <TileLayer
        attribution='&amp;copy <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
        tms={this.planet.tms}
        noWrap={true}
        url={this.planet.url}
      />
      {this.preparePolygons(this.props.regions).filter(item => !item.draggable).map(item => <Polygon {...item} eventHandlers={{click: () => this.props.onPolygonClick(item)}} />)}
      {this.preparePolygons(this.props.regions).filter(item => item.draggable).map(item => <TrueSize {...item} eventHandlers={{click: () => this.props.onPolygonClick(item)}} onDragEnd={this.props.onDragPolygon}/>)}
      {this.preparePoints(this.props.points).map(item => <Circle {...item} eventHandlers={{click: () => this.props.onPolygonClick(item)}}/>)}
      {marker && <Marker position={marker.position}/>}
    </MapContainer>;
  }
}


export default LeafletMap;
